import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncLegacyLogin = loadable(() => import('./LegacyLogin'), {
  fallback: <Loader />,
});

export const AsyncOneTimeTokenLegacyLogin = loadable(
  () => import('./OneTimeTokenLegacyLogin'),
  {
    fallback: <Loader />,
  },
);
